import { Collapse } from 'antd'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import Button from '../../../components/button'
import Text from '../../../components/text'
import { ROUTES } from '../../../core/actions'
import { useAuth } from '../../../core/AuthContext'
import {
  BUYER_LINK,
  COMPANY_NAME,
  DBS_BACKEND_API_URL,
  ICICI_BACKEND_API_URL,
  IDFC_BACKEND_API_URL,
  isTradecred,
  TRADECRED_SUPPORT_EMAIL,
} from '../../../core/constants'
import * as styles from './Faq.css'
const { Panel } = Collapse

export const Faq = () => {
  let host = ''
  const {
    authState: { baseUrl },
  } = useAuth()
  switch (baseUrl) {
    case ICICI_BACKEND_API_URL:
      host = 'ICICI'
      break
    case IDFC_BACKEND_API_URL:
      host = 'IDFC'
      break
    case DBS_BACKEND_API_URL:
      host = 'DBS'
      break
    default:
      break
  }
  const BANK_NAME = host === 'ICICI' ? 'ICICI' : host === 'IDFC' ? 'IDFC' : 'DBS'
  const IFSC_CODE = host === 'ICICI' ? 'ICIC0000106' : host === 'IDFC' ? 'IDFB0040101' : 'DBSS0IN0811'
  const BRANCH_NAME = host === 'ICICI' ? 'RPC Delhi' : host === 'IDFC' ? 'BKC - Naman Chambers' : 'Mumbai'

  const GeneralQueries = [
    {
      key: 1,
      query: `How to register as a Buyer on ${COMPANY_NAME}?`,
      answer: `To register as a Buyer:<br/> a) Go to ${TRADECRED_SUPPORT_EMAIL} or open the mobile application;<br/> b) Click on Register;<br/> c) Choose the buyer type (Individual/HUF/Partnership Firm/LLP/Private/ Public Limited Company / NBFC / Bank/NRI<br/> d) Fill all the details of the buyer as asked on the page. Also, upload necessary documents as per the requirement<br/> e) Once everything is done, click on submit.<br/><br/> After the request has been received by us, KYC verification and registration process shall be completed within 24 working hours, if all the documents submitted are correct.<br/><br/> A welcome mail will be received by the applicant on registered email address.<br/> `,
    },
    {
      key: 2,
      query: `What is the difference between masked EAadhaar & unmasked EAadhaar?`,
      answer: `Masked Aadhaar Card only shows the last 4 digits of the Aadhaar number instead of the 12 digits in the regular one whereas Unmasked Aadhaar card shows all the 12 digits of your Aadhaar card.<br/> E.g.: Unmasked Aadhaar No.: 1234 5678 9012; Masked Aadhaar No.: XXXX XXXX 9012.<br/>`,
    },
    {
      key: 3,
      query: `What is a Buyer Escrow account?`,
      answer: `It is a virtual account which is linked to the Buyer and can be used to add funds to the wallet.<br/>`,
    },
    {
      key: 6,
      query: `How do I check my transaction history?`,
      answer:
        'To check your transactions and their current status, log into to your account, go to `Portfolio Page`. There you can find the status for the following:-<br/> a) Ongoing deals<br/> b) Pending for approval deals<br/> c) Completed deals<br/>',
    },
    {
      key: 7,
      query: `What is the duration of a deal? Is there a lock-in period for the deals? Can they be withdrawn anytime?`,
      answer: `The duration of the deal is varies from 30 days to 90 days. The Buyer’s monies are locked-in for such duration. <br/>`,
    },
    {
      key: 8,
      query: `When does the dashboard get updated after purchasing a deal?`,
      answer: `Dashboard gets updated in maximum 24 working hours after a deal is purchased.<br/>`,
    },
  ]

  const WalletQueries = [
    {
      key: 9,
      query: `How to transfer monies to a Buyer's Escrow Account? How much time does it take to reflect the monies transferred to Buyer's Escrow Account?`,
      answer: `For adding the money to your wallet, Buyer has to add the escrow account (mentioned in the welcome mail) as a beneficiary in their bank accounts. The same shall be in following format:<br/><br/> Bank Account : 10051800xxxx<br/> Bank Account Holder Name: (Your Name)<br/> Bank Name: ${BANK_NAME} Bank<br/> IFSC Code: ${IFSC_CODE}<br/> Branch: ${BRANCH_NAME}<br/><br/> While adding as a beneficiary, kindly note:<br/> *Add the escrow account as 'Other Bank Beneficiary' (Even if the Buyer's bank account is with ${BANK_NAME} bank, add the escrow account as 'Other Bank Beneficiary' only)<br/><br/> *The account type shall be 'Current Account'<br/><br/> *Please do not use IMPS.<br/><br/> It takes upto 24 working hours to reflect the monies transferred in the Buyer's Escrow Account.<br/> `,
    },
    {
      key: 10,
      query: `How to withdraw monies from a Buyer's Escrow Account? How much time does it to reflect the monies withdrawn to Buyer's bank account?`,
      answer: `Buyer can withdraw the monies by pressing the 'Withdraw' button in the 'Overview' section in the mobile application or in the 'Dashboard' section in the web. In case you have not added your bank account details, you need to add the same first.<br/> (It may take upto 24 working hours to reflect the monies withdrawn from the Buyer's Escrow Account in the Buyer's bank account.)<br/> *Second Saturday/Fourth Saturday/Sunday being bank holidays, monies withdrawn shall hit your bank account on Monday and in case of any other Bank holiday, the next working day.<br/>`,
    },
    {
      key: 11,
      query: `Can monies be transferred to the Buyer Escrow Account (wallet) from any bank account other than registered bank account?`,
      answer: `There are no restrictions on the bank account used to transfer monies into the Buyer Escrow Account (wallet).<br/>`,
    },
    {
      key: 12,
      query: `Can the monies be withdrawn to any bank account other than registered bank account?`,
      answer: `No. Monies on account of wallet withdrawal shall be transferred to registered bank account only. Also, if the bank details updated on the platform do not belong to the buyer, the system shall fail to process the same.<br/>`,
    },
  ]

  const DealQueries = [
    {
      key: 13,
      query: `How to purchase a deal?`,
      answer: `To purchase a deal, please follow the following steps:-<br/> Through website:<br/> a) Login to ${BUYER_LINK}<br/> b) Go to “Current Deals”.<br/> c) Available deals shall be visible on this page. Choose a deal, enter the amount and click on “Buy Deal” tab.<br/> d) Input the OTP sent to the registered email id in the transaction window and click on “Proceed to Sign”;<br/> e) The draft Confirmation of Purchase (CoP) shall be generated. Click on “Proceed” after perusing the draft CoP;<br/> f) Input the Aadhaar number of the Buyer (Authorised User) on the NSDL E-Sign page and click on “Send OTP”;<br/> g) An OTP shall be sent to your Aadhaar registered mobile number. Input the OTP and click on “Verify OTP”. The deal shall be purchased.<br/><br/> ${
        isTradecred
          ? `Through Mobile App:<br/> a) Login to ${COMPANY_NAME} App;<br/> b) Go to “Deals”;<br/> c) Available deals shall be visible on this page. Choose a deal, enter the amount and click on “Buy Now” tab;<br/> d) Input the OTP sent on your Aadhaar registered mobile number. The deal shall be purchased.<br/>`
          : ``
      }`,
    },
    {
      key: 14,
      query: `How are the earnings calculated?`,
      answer: `For calculations, please use this formula :-<br/> Fv = Pv(1+r)^n<br/> where,<br/> Fv = Future Value<br/> Pv = Present Value<br/> r = Net IRR per annum (as per the mail received on deal purchase)<br/> n = tenure (tenure is Number of days/365)<br/> `,
    },
    {
      key: 15,
      query: `What is an Effective Date/ Deal Date?`,
      answer: `An Effective Date/ Deal Date is an actual deal purchase date from which the earnings meter of the Buyer starts. This date changes every day after 5:00 p.m.<br/> Any deal purchased after 5:00 p.m. on Saturday shall have the deal date of coming Monday.<br/> E.g.: Any deal purchased after 5:00 p.m. on T shall have T+1 as the deal date.<br/> `,
    },
    {
      key: 16,
      query: `Will the Customer repay the monies directly to the Seller Escrow Account or will it be received by Seller who shall then make the repayment?`,
      answer: `The Customer will repay directly to the Seller Escrow Account from where the amount deals shall be repaid and funds shall be transferred to Buyer Escrow Account.<br/>`,
    },
    {
      key: 17,
      query: `What happens if any Buyer fails to contact ${COMPANY_NAME} on the due date?`,
      answer: `When a deal matures, ${COMPANY_NAME} sends system generated email to the respective Buyers regarding the same. There is no need for the Buyer to contact ${COMPANY_NAME}.<br/>`,
    },
    {
      key: 18,
      query: `What is the range of earnings that can be earned by the Buyer?`,
      answer: `The Buyer can earn earnings ranging between 10% to 15% on a particular deal.<br/>`,
    },
  ]

  const NonConvertibleDebenturesQueries = [
    {
      key: 26,
      query: `What is the product all about?`,
      answer: `Debentures are long term financial instruments issued by a company for specified tenure with a promise to pay fixed returns to the investor. NCDs cannot be converted into equities or shares. Their rates are decided by the company issuing it.`,
    },
    {
      key: 27,
      query: `Why companies issue NCD?`,
      answer: `The companies issue NCD to raise capital from public issues for a specified tenure.`,
    },
    {
      key: 28,
      query: `Who can invest in NCD?`,
      answer: `It can be held by individuals, banking companies, primary dealers, or other corporate bodies registered or incorporated in India, unincorporated bodies, Non Resident of India (NRIs), Foreign Institutional Investors (FIIs).`,
    },
    {
      key: 29,
      query: `Are these secured?`,
      answer: `Yes, the NCDs are highly secured. The issue of debentures shall be secured by the creation of charge, on the property or assets, or receivables of the company having value which is sufficient for the due repayment of the amount in relation to the debentures and interest.`,
    },
    {
      key: 31,
      query: `What is the tenure?`,
      answer: `The tenure can vary from 2 years to 20 years.`,
    },
    {
      key: 32,
      query: `What is the Tax treatment?`,
      answer: `10% TDS will be deducted, and it will be reflected in Form 26 AS. You shall be able to claim a refund by filing the tax returns.`,
    },
    {
      key: 33,
      query: `Are you paying more taxes?`,
      answer: `No, if you are in the tax slab of 20% or 30%, you are anyway paying tax at the same rate.The TDS will be paid from the Obligor instead of you paying it upfront.`,
    },
    {
      key: 34,
      query: `Are there any guarantees offered by ${COMPANY_NAME}?`,
      answer: `As a technology platform, ${COMPANY_NAME} does not offer any guarantee, whatsoever.`,
    },
  ]

  const RiskQueries = [
    {
      key: 35,
      query: `What is the fee structure? Are there any charges while investing on the platform?`,
      answer: `There are no fees. The net IRR percentage shown on the screen while you transact is after deduction of all costs.<br/>`,
    },
    {
      key: 36,
      query: `What happens if there is any delay in repayments? Do we get the earnings till the due date only?`,
      answer: `In case of delay in repayments, the Buyer shall receive the earnings as per the net IRR of the deal till the actual date of repayment and not only till the due date.<br/>`,
    },
    {
      key: 37,
      query: `Which Entity is liable for making repayments?`,
      answer: `The Seller (Vendor) is liable to make the repayments in case it's Customer does not make the repayment. In cases where the Customer is liable to repay, the Offer for Sale shall also be signed by the Customer.<br/>`,
    },
    {
      key: 38,
      query: `Does ${COMPANY_NAME} hold any post-dated cheques (PDCs) which in case of default be used?`,
      answer: `${COMPANY_NAME} holds post-dated cheques (PDCs) of the Entity who is liable to make the repayments.<br/>`,
    },
    {
      key: 39,
      query: `When is the Entity liable to repay shall be considered to have defaulted in repaying a deal?`,
      answer: `If the Entity liable to repay the deal proceeds wilfully does not repay them within seven working days of the settlement date plus grace days mentioned in the Confirmation of Purchase or any incident which endangers the repayment capacity of the Entity liable to repay then a default is committed. ${COMPANY_NAME} shall start the recovery measures as soon as it senses a default.<br/>`,
    },
    {
      key: 40,
      query: `What are the measures adopted by ${COMPANY_NAME} for recovery in case of default?`,
      answer: `When a default is committed, ${COMPANY_NAME} shall take following recovery measures:<br/><br/>1. Stopping of pass-through of funds received from Seller's (Vendor) Customer to the Seller (Vendor);<br/>2. Encashing the post-dated cheques (PDCs);<br/>3. Sending demand notice under section 8 of the Insolvency and Bankruptcy Code, 2016.<br/>4. Other recovery measures which ${COMPANY_NAME} shall consider expedient.<br/>`,
    },
    {
      key: 41,
      query: `What measures are taken by ${COMPANY_NAME} to assess possible bankruptcy/failure to make payment by a seller?`,
      answer: `We have very strong risk mitigation measures. We rely on invoice and escrow confirmations by Large Corporates and not SMEs. We also do multiple financial health checks depending on factors, market situations & Product. As of now, we are a Zero default company.<br/>`,
    },
  ]

  const queryTitles = ['General FAQs', 'Wallet FAQs', 'Deal FAQs', 'Non Convertible FAQs', 'Risks FAQs']

  const queries = [GeneralQueries, WalletQueries, DealQueries, NonConvertibleDebenturesQueries, RiskQueries]
  const navigate = useNavigate()
  const handleBackIconPress = () => navigate(ROUTES.FINANCIER)

  return (
    <div className={styles.faq}>
      <div className={styles.header}>
        <div className={styles.headerText}>
          <Button handleClick={handleBackIconPress} type='icon' className={styles.backButton}>
            <ion-icon name={'arrow-back'} />
          </Button>
          <Text size='1.3' bold className={styles.title}>
            Frequently Asked Questions
          </Text>
        </div>
        <Text size='0.88' className={styles.contact}>
          For any queries, please email
          <a href={`mailto:${TRADECRED_SUPPORT_EMAIL}`}> {TRADECRED_SUPPORT_EMAIL}</a>.
        </Text>
      </div>
      <Collapse accordion defaultActiveKey={['0']} ghost>
        {queryTitles.map((title, index) => {
          return (
            <Panel
              key={index}
              header={
                <Text size='1' bold className={styles.titleText}>
                  {title}
                </Text>
              }>
              <div className={styles.queryClusters} key={title}>
                <Collapse accordion defaultActiveKey={['1']}>
                  {queries[index].map(query => (
                    <Panel key={query.key} header={<Text size='0.92'>{query.query}</Text>}>
                      <Text size='0.88' className={styles.answer}>
                        <p dangerouslySetInnerHTML={{ __html: query.answer }} />
                      </Text>
                    </Panel>
                  ))}
                </Collapse>
              </div>
            </Panel>
          )
        })}
      </Collapse>
    </div>
  )
}
